import { createFileRoute } from '@tanstack/react-router'

import { Team } from '@/widgets/team'

export const Route = createFileRoute('/_app/team')({
  component: RouteComponent,
})

export const TeamRoute = Route

function RouteComponent() {
  return <Team />
}
